import { getNameFromFileId } from "@/utils/get-name-from-file-id";
import { removeEmptyPathSegments } from "@/utils/remove-empty-path-segments";

import { FileModalMode } from "./file-modal-mode";

export const getInitialPathSegments = (fileId: string | undefined, mode: FileModalMode) => {
  // filters out trailing slashes
  const pathParts = removeEmptyPathSegments(fileId?.split("/") ?? []);
  const isExistingDirectory = mode === "input-directory";

  // Existing directories use the complete ID as the directory being viewed.
  // Files and output destinations keep their final segment as the selected or entered name.
  return isExistingDirectory ? pathParts : pathParts.slice(0, -1);
};

export const getInitialFileName = (
  fileId: string | undefined,
  mode: FileModalMode,
  temporaryFileName: string | undefined
) => {
  if (mode === "input-directory") return temporaryFileName;
  return temporaryFileName ?? getNameFromFileId(fileId ?? "");
};

export const getFileDestinationId = (mode: FileModalMode, path: string, fileName = "") => {
  if (mode === "input-directory") return path;
  if (mode === "output-directory") return path + fileName + (fileName ? "/" : "");

  // file modes
  return path + fileName;
};
